import {Component, Module} from 'app/decorators';
import NutrientStore from 'app/stores/nutrient';

import BasePicker from './base.picker';
import tpl from './nutrient.picker.html';


@Module({
    name: "app.directives.nutrientpicker",
    modules: [NutrientStore],

})
@Component({
    selector: 'blnd-nutrient-picker',
    bindings: {
        ngModel: '=',
        mode: '@?',
    },
    template: tpl,
})
export default class C extends BasePicker {
    constructor (NutrientStore, $element) {
        "ngInject";
        super($element);
        this.mode = this.mode || 'view';
        this.store = NutrientStore;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/nutrient.picker.js